import {
  ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, EventEmitter, forwardRef, Input, Output, ViewContainerRef,
  ViewChild, AfterViewInit, Renderer2
} from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AxisFile } from './axisFile';
import { FileuploadAlertComponent } from './fileupload-alert.component';

@Component({
  selector: 'axis-upload, [axis-upload]',
  templateUrl: './fileupload.component.html',
  styles: [
    `
    .pointerEvents {
      pointer-events: none !important;
    }
    .borderHighlight {
      border: 3px dashed #00a4e4;
    }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UploadComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => UploadComponent),
      multi: true
    }
  ]
})
export class UploadComponent implements AfterViewInit {
  @Input() documentFlag = false;
  @Input() imagePreview = false;
  @Input() kind = 'link';
  @Input('data-kind')
  get dataKind(): string { return this.kind; }
  set dataKind(value: string) {
    this.kind = value;
  }
  @Input() type: string;
  @Input() title: string;
  @Input() restrictFiles = '';
  @Input() isMulti = true;
  @Input() isAppendable = true;
  @Input() maxFileSize: number;
  @Input() allowUniqueFileName = true;
  @Input() font = 'custom';
  @Input() required = false;
  @Input() disabled = false;
  @Input() updateOn = 'blur';
  @Input() name;
  @Input() invalidFileMsg = 'File type is not supported.';

  @Output() listChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() discardedFilesListEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() largerFilesEmitter: EventEmitter<any> = new EventEmitter<any>();


  @ViewChild('buttonRef') buttonRef: ElementRef;
  @ViewChild('singleinput') singleinput: ElementRef;
  @ViewChild('multiinput') multiinput: ElementRef;
  @ViewChild('ddsingleinput') ddsingleinput: ElementRef;
  @ViewChild('ddmultiinput') ddmultiinput: ElementRef;
  @ViewChild('cloudIcon', { read: ElementRef }) private cloudIcon: ElementRef;
  @ViewChild('singleUploadButton', { read: ElementRef }) private singleUploadButton: ElementRef;
  @ViewChild('multiUploadButton', { read: ElementRef }) private multiUploadButton: ElementRef;

  public uploadFileList: Array<AxisFile> = new Array<AxisFile>();
  public invalidFilesList: Array<AxisFile> = new Array<AxisFile>();
  public largerFilesList: Array<AxisFile> = new Array<AxisFile>();
  public isDragDrop = false;
  public startValidate = false;
  public isCursorClass = false;
  public borderHighlight = false;
  public customButton = false;

  constructor(
    private sanitizer: DomSanitizer,
    public _changeDetRef: ChangeDetectorRef,
    public el: ElementRef,
    public renderer: Renderer2,
    private resolver: ComponentFactoryResolver,
    private viewRef: ViewContainerRef,
  ) {
    this.uploadFileList = new Array<AxisFile>();
  }

  private propagateModelChange = (_: any) => { };
  private OnTouchedEvent = () => { };

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  ondragenter(event) {
    if (!this.disabled) {
      this.addPointerEventsClass();
      this.isDragDrop = true;
      this.borderHighlight = true;
    }
  }

  ondragleave(event) {
    this.borderHighlight = false;
    this.removePointerEventsClass();
    this.isDragDrop = false;
  }

  ondragend(event) {
    this.removePointerEventsClass();
    this.isDragDrop = false;
    this.borderHighlight = false;
  }

  addPointerEventsClass() {
    if (this.multiUploadButton) {
      this.multiUploadButton.nativeElement.classList.add('pointerEvents');
    }
    if (this.singleUploadButton) {
      this.singleUploadButton.nativeElement.classList.add('pointerEvents');
    }
    if (this.cloudIcon) {
      this.cloudIcon.nativeElement.classList.add('pointerEvents');
    }
  }

  removePointerEventsClass() {
    if (this.multiUploadButton) {
      this.multiUploadButton.nativeElement.classList.remove('pointerEvents');
    }
    if (this.singleUploadButton) {
      this.singleUploadButton.nativeElement.classList.remove('pointerEvents');
    }
    if (this.cloudIcon) {
      this.cloudIcon.nativeElement.classList.remove('pointerEvents');
    }
  }

  getImageThumbnail(data) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      const sanitizer = this.sanitizer;
      reader.onload = function (e) {
        data.src = sanitizer.bypassSecurityTrustResourceUrl(reader.result.toString());
        resolve(data.src);
      };
      reader.readAsDataURL(data.file);
    });
  }

  loadthumbnails() {
    let af: AxisFile;
    const promises: Array<any> = new Array<any>();
    for (let i = 0; i < this.uploadFileList.length; i++) {
      af = this.uploadFileList[i];
      const sanitizer = this.sanitizer;
      if (af.src) {
        af.src = sanitizer.bypassSecurityTrustResourceUrl
          (af.src.changingThisBreaksApplicationSecurity ? af.src.changingThisBreaksApplicationSecurity : af.src);
      } else {
        promises.push(this.getImageThumbnail(af));
      }
    }
    Promise.all(promises).then(() => {
      this['listChange'].emit(this.uploadFileList);
    });
  }

  change(event) {
    this.startValidate = true;
    if (event.currentTarget.files.length > 0) {
      if (!this.isAppendable || !this.isMulti) {
        this.uploadFileList = new Array<AxisFile>();
      }
      let af: AxisFile;
      let isValidFormatFile: any = 0;
      this.invalidFilesList = [];
      this.largerFilesList = [];
      for (let i = 0; i < event.currentTarget.files.length; i++) {
        af = new AxisFile();
        af.file = event.currentTarget.files[i];
        af.id = i;
        let fileType: any = af.file.name.split('.');
        fileType = fileType[fileType.length - 1];
        af.icon = this.setIcon(fileType, af);
        if (this.restrictFiles) {
          isValidFormatFile = this.restrictFiles.toLowerCase().split(" ").join("").split(",").indexOf('.' + fileType.toLowerCase());
        }
        if (
          !this.isFileAlredySelected(af) &&
          isValidFormatFile >= 0 &&
          ((this.maxFileSize && af.file.size <= this.maxFileSize) ||
            !this.maxFileSize)
        ) {
          this.uploadFileList.push(af);
        } else if (isValidFormatFile === -1) {
          this.invalidFilesList.push(af);
          this.showAlert();
        } else if (this.maxFileSize && af.file.size > this.maxFileSize) {
          this.largerFilesList.push(af);
        }
      }
      for (let i = 0; i < this.uploadFileList.length; i++) {
        this.uploadFileList[i].id = i;
      }
      if (this.imagePreview) {
        this.loadthumbnails();
      } else {
        this.listChange.emit(this.uploadFileList);
      }
      if (this.invalidFilesList && this.invalidFilesList.length > 0) {
        this.discardedFilesListEmitter.emit(this.invalidFilesList);
      }
      if (this.largerFilesList && this.largerFilesList.length > 0) {
        this.largerFilesEmitter.emit(this.largerFilesList);
      }
      if (this.singleinput) {
        this.singleinput.nativeElement.value = null;
      }
      if (this.multiinput) {
        this.multiinput.nativeElement.value = null;
      }
      if (this.ddsingleinput) {
        this.ddsingleinput.nativeElement.value = null;
      }
      if (this.ddmultiinput) {
        this.ddmultiinput.nativeElement.value = null;
      }
    }
    this.propagateModelChange(this.uploadFileList);
  }

  showAlert() {
    const factory = this.resolver.resolveComponentFactory(FileuploadAlertComponent);
    const componentRef = this.viewRef.createComponent(factory);
    this.el.nativeElement.appendChild(
      componentRef.location.nativeElement
    );
    componentRef.instance.invalidFileMsg = this.invalidFileMsg;
  }
  isFileAlredySelected(checkFile: AxisFile) {
    if (this.allowUniqueFileName) {
      let af: AxisFile;
      for (let i = 0; i < this.uploadFileList.length; i++) {
        af = this.uploadFileList[i];
        if (checkFile.file.name === af.file.name) {
          return true;
        }
      }
    }
    return false;
  }

  delete(file: AxisFile) {
    const index = this.uploadFileList.indexOf(file);
    if (index !== -1) {
      this.uploadFileList.splice(index, 1);
    }
    this.listChange.emit(this.uploadFileList);
    this.propagateModelChange(this.uploadFileList);
  }

  onUploadDragOver(event) {
    if (
      !this.disabled &&
      (event.dataTransfer.types[0] === 'Files' ||
        event.dataTransfer.types[1] === 'Files')
    ) {
      event.preventDefault();
    }
  }

  onUploadDrop(event) {
    if (!this.disabled) {
      this.startValidate = true;
      if (event.dataTransfer.types[0] === 'Files' || event.dataTransfer.types[1] === 'Files') {
        event.preventDefault();
      }
      if (!this.isAppendable || !this.isMulti) {
        this.uploadFileList = new Array<AxisFile>();
      }
      let af: AxisFile;
      let isValidFormatFile: any = 0;
      this.invalidFilesList = [];
      this.largerFilesList = [];
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        af = new AxisFile();
        af.file = event.dataTransfer.files[i];
        af.id = i;
        let fileType: any = af.file.name.split('.');
        fileType = fileType[fileType.length - 1];
        af.icon = this.setIcon(fileType, af);
        if (this.restrictFiles) {
          isValidFormatFile = this.restrictFiles.toLowerCase().split(" ").join("").split(",").indexOf('.' + fileType.toLowerCase());
        }
        if (
          !this.isFileAlredySelected(af) &&
          isValidFormatFile >= 0 &&
          ((this.maxFileSize && af.file.size <= this.maxFileSize) ||
            !this.maxFileSize)
        ) {
          this.uploadFileList.push(af);
        } else if (isValidFormatFile === -1) {
          this.invalidFilesList.push(af);
          this.showAlert();
        } else if (this.maxFileSize && af.file.size > this.maxFileSize) {
          this.largerFilesList.push(af);
        }
        if (!this.isMulti) {
          break;
        }
      }
      if (this.imagePreview) {
        this.loadthumbnails();
      } else {
        this.listChange.emit(this.uploadFileList);
      }
      if (this.invalidFilesList && this.invalidFilesList.length > 0) {
        this.discardedFilesListEmitter.emit(this.invalidFilesList);
      }
      if (this.largerFilesList && this.largerFilesList.length > 0) {
        this.largerFilesEmitter.emit(this.largerFilesList);
      }
      this.isDragDrop = false;
      this.borderHighlight = false;
      this.propagateModelChange(this.uploadFileList);
    }
  }

  setIcon(fileType, af): string {
    let icon: string;
    if (af.file.type.toLowerCase().indexOf('image') === -1) {
      if (fileType === 'docx') {
        icon = 'doc';
      } else if (fileType === 'pptx') {
        icon = 'ppt';
      } else if (fileType === 'msg') {
        icon = 'mail';
      } else if (fileType === 'xlsx') {
        icon = 'xls';
      } else {
        icon = fileType;
      }
    }
    return icon;
  }

  reset() {
    this.uploadFileList = [];
    this.loadthumbnails();
  }

  onSingleBrowse(event) {
    event.stopPropagation();
    event.preventDefault();
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      setTimeout(() => {
        this.singleinput.nativeElement.click();
      }, 1000); // settimeout is given 1 sec to solve fileupload in firefox
    } else {
      this.singleinput.nativeElement.click();
    }
  }

  onMultiBrowse(event) {
    event.stopPropagation();
    event.preventDefault();
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      setTimeout(() => {
        this.multiinput.nativeElement.click();
      }, 1000); // settimeout is given 1 sec to solve fileupload in firefox
    } else {
      this.multiinput.nativeElement.click();
    }
  }

  onDDBrowse(event) {
    if (!this.disabled) {
      if (this.isMulti) {
        this.onDDMultiBrowse(event);
      } else {
        this.onDDSingleBrowse(event);
      }
    }
  }

  changeCursor(event) {
    if (this.disabled) {
      event.target.style.cursor = 'not-allowed';
    } else {
      event.target.style.cursor = 'pointer';
    }
  }

  onDDSingleBrowse(event) {
    event.stopPropagation();
    event.preventDefault();
    this.ddsingleinput.nativeElement.click();
  }

  onDDMultiBrowse(event) {
    event.stopPropagation();
    event.preventDefault();
    this.ddmultiinput.nativeElement.click();
  }
  stopPropagation(event) {
    event.stopPropagation();
  }

  writeValue(value: any) {
    this.reset();
    this.uploadFileList = [];
    if (Array.isArray(value)) {
      this.uploadFileList = value;
      if (this.imagePreview) {
        this.loadthumbnails();
      }
    } else if (value && Object.keys(value).length) {
      this.uploadFileList.push(value);
      if (this.imagePreview) {
        this.loadthumbnails();
      }
    }
  }

  registerOnChange(fn: any): void {
    this.propagateModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.OnTouchedEvent = fn;
  }

  onTouched() {
    this.OnTouchedEvent();
  }

  validate(control: AbstractControl): { [key: string]: any } {
    if (this.required) {
      if (this.startValidate === true) {
        if (this.uploadFileList.length > 0) {
          return null;
        }
        return { axisFileUpload: { valid: false } };
      }
    }
  }

  ngAfterViewInit() {
    if (this.buttonRef !== undefined && this.buttonRef.nativeElement.childNodes.length > 0) {
      this.customButton = true;
      this._changeDetRef.detectChanges();
      const targetElemnt = this.el.nativeElement.children[0];
      if (!targetElemnt.attributes.hasOwnProperty('data-kind')) {
        this.renderer.setAttribute(
          targetElemnt,
          'data-kind',
          'link'
        );
      }
      if (!targetElemnt.attributes.hasOwnProperty('title')) {
        this.renderer.setAttribute(
          targetElemnt,
          'title',
          'Select File'
        );
      } else if (targetElemnt.attributes.hasOwnProperty('title')) {
        if (targetElemnt.getAttribute('title') === '') {
          this.renderer.setAttribute(
            targetElemnt,
            'title',
            'Select File'
          );
        }
      }
      if (targetElemnt.attributes.hasOwnProperty('disabled')) {
        if (targetElemnt.getAttribute('disabled') === true) {
          this.renderer.setAttribute(
            targetElemnt,
            'disabled',
            'true'
          );
        } else {
          this.renderer.setAttribute(
            targetElemnt,
            'disabled',
            'null'
          );
        }
      }
      let clickFunction;
      if (this.isMulti) {
        clickFunction = this.onMultiBrowse.bind(this);
      } else {
        clickFunction = this.onSingleBrowse.bind(this);
      }
      this.el.nativeElement.addEventListener('click', (event) => {
        clickFunction(event);
        this.onTouched();
        event.preventDefault();
        event.stopPropagation();
      });
    } else {
      this.customButton = false;
    }
  }
}
